export const GET_USER_REQUEST: 'GET_USER_REQUEST' = 'GET_USER_REQUEST';
export const GET_USER_FAILED: 'GET_USER_FAILED' = 'GET_USER_FAILED';
export const GET_USER_SUCCESS: 'GET_USER_SUCCESS' = 'GET_USER_SUCCESS';

export const GET_TOKEN_REQUEST: 'GET_TOKEN_REQUEST' = 'GET_TOKEN_REQUEST';
export const GET_TOKEN_FAILED: 'GET_TOKEN_FAILED' = 'GET_TOKEN_FAILED';
export const GET_TOKEN_SUCCESS: 'GET_TOKEN_SUCCESS' = 'GET_TOKEN_SUCCESS';